import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { gaFunction } from "../../Router";
import { getBinaryUserDataPanDob } from "../../services/vendorServices/binary-service";
import { storeToken } from "../Redux/authSlice";
import { coPreloadData } from "../Redux/corporatePreloadData";
import { showGlobalError } from "../Redux/globalErrorSlice";
import { documentDetail } from "../Redux/otherDocsSlice";
import { panUserdata } from "../Redux/panCardSlice";
import { updateMarutiUserDetails } from "../Redux/partnerChannelNameSlice";
import { customerData, updateUserData } from "../Redux/userData";
import { corporateDropDownValue ,corporateCompanyType, corporateCDD, coAddNewKycIdReducer, updateCompanyName, updateIsRecordExist} from "../Redux/corporateSlice";
// import { updatePartnerDigiJourneyFlag } from "../Redux/partnerDigiJourneyFlagSlice";
import { toggleTabs } from "../../Screens/Redux/slice";
import axios from "axios";
import { channel } from "process";
import { kycName, kycRefId, updateIsIDV3, updateIsRpt, updateIsRecordExist as  updateIsRecordExistInd} from "../Redux/kycDetailsSlice";
import { userPanNumberDetails } from "../Redux/AdhaarRedirectInfoSlice";
import { KydDetailsByKycID } from "../../services/vendorServices/partner-service";

const VerifiedPartner = () => {
  const { token } = useSelector((state) => state.authSlice);
  const { customerType ,mi_u, channelUrl} = useSelector(
    (state) => state.partnerChannelNameSlice.marutiUserDetails
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();

   let url = window.location.search;
    const urlParams = new URLSearchParams(url);
    let channelName = urlParams.get("channel");
    console.log(channelName)
    let Is_IDV3Params = urlParams.get("Is_IDV3");
   let kycID= urlParams.get("kycId")
    let Is_IDV3_Boolean = Is_IDV3Params === "true" || Is_IDV3Params === 1; 
    let isRptParams = urlParams.get("isRpt");
    let isRptBoolean = isRptParams === "true" || isRptParams === true;
    
  const resetDB = useCallback(() => {
    dispatch(panUserdata({}));
    dispatch(documentDetail({ dob: "", fatherName: "" }))
    dispatch(customerData({ fatherName: "" }))
    dispatch(updateUserData({ phoneNumber: "" }))
    dispatch(corporateCompanyType(""))
    dispatch(corporateDropDownValue(""));
  }, [dispatch])

  useEffect(() => {
    //binary login
    if (window.location.pathname === "/verified-partner") {
      let channelName;
      let partnerDigiJourneyFlag;
      let mTxn = "";
      let url = window.location.search;
      const urlParams = new URLSearchParams(url);
      channelName = urlParams.get("channel");
      // partnerDigiJourneyFlag = urlParams.get("partnerDigiJourney");
      // dispatch(updatePartnerDigiJourneyFlag(partnerDigiJourneyFlag));
      gaFunction(`${channelName}`, `${channelName} logged in`);
      mTxn = urlParams.get("txnId");
      let subChannel = urlParams.get("subChannel");
      console.log("subChannel",subChannel)
      let mobile = urlParams.get("mobile"); 
      updateUserData({
        panNumber: "",
        dob: "",
        mobileNumber:mobile||""
      });
      resetDB()
      dispatch(
        updateMarutiUserDetails({
          channelUrl: channelName,
          mi_u: mTxn,
          customerType: urlParams.get("customerType") || "I",
          subChannel:subChannel,
        })
      );
      dispatch(updateIsIDV3(Is_IDV3_Boolean))
      dispatch(updateIsRpt(isRptBoolean))
      console.log("uelredirect",urlParams.get("redirectUrl"))
      dispatch(storeToken(urlParams.get("token")));
      localStorage.setItem("txnId", urlParams.get("txnId"));
      localStorage.setItem("token", urlParams.get("token"));
      localStorage.setItem(
        "redirectUrl",
        decodeURIComponent(urlParams.get("redirectUrl"))
      );
      localStorage.setItem("channel", urlParams.get("channel"));
      localStorage.setItem(
        "callbackUrl",
        decodeURIComponent(urlParams.get("callbackUrl"))
      );
      if (channelName !== null || channelName?.length > 0) {
        if ((channelName === "binary" && urlParams.get("customerType") === "C") || channelName === "AMAZON") {
          getBinaryUserDataPanDob({
            txnId: mTxn || "",
            channelUrl: channelName || "",
          })
            .then((response) => {
              if (response?.success === true) {
                if (Object.keys(response?.data)?.length > 1) {
                 if(channelName === "AMAZON"){
                  dispatch(userPanNumberDetails(response?.data?.pan || ""));
                  dispatch(
                    updateUserData({
                      panNumber: response?.data?.pan,
                      dob: response?.data?.dob
                        ?.split("/")
                        ?.join("-"),
                    })
                  );
                 }else{
                    dispatch(
                      coPreloadData({
                        pan: response?.data?.pan || "",
                        doi: response?.data?.dob
                          ?.split("/")
                          ?.join("-"),
                        cin: response?.data?.cinnumber || "",
                        ckyc: response?.data?.ckycnumber || "",
                      })
                    );
                  }
                 }
                }
            })
            .catch((err) => {
              dispatch(
                showGlobalError("Something went wrong. Please try again")
              );
              navigate("/*");
            });
        } else {
          coPreloadData({
            pan: "",
            doi: "",
            cin: "",
            ckyc: "",
          })
        }
        // navigate("/kyc");
      }
    }
  }, [dispatch, resetDB]);

  useEffect(() => {
    if (token && customerType === "I") {  
      if(kycID && Is_IDV3_Boolean){
        KydDetailsByKycID(kycID,"I")
          .then((response) => {
            console.log(response)
            if (response?.success === true) {
              if (Object.keys(response?.data)?.length > 1) {
                const {annualIncome,organizationType,occupation,nationality,citizenship,isPoliticallyExposed }= response?.data // to be changed after checking 
                // dispatch(updateUserData({ name,panNumber}));
                dispatch(customerData({annualIncome: annualIncome,
                occupation: occupation,
                organization: organizationType,
                citizenship: citizenship,
                nationality: nationality,
                political: isPoliticallyExposed}));
                dispatch(kycName(response?.data[`${response?.data.lastServiceWhichUpdated}`.toLowerCase()].name))
                dispatch(kycRefId(kycID))
                dispatch(updateIsRecordExistInd(true))
                navigate("/eddDetails",{
                  state: { modal: true },
                });
               }
              }
          })
          .catch((err) => {
            dispatch(
              showGlobalError("Something went wrong. Please try again")
            );
            navigate("/*");
          });
      }
      if(channelName == "AMAZON"){
        console.log(channelName)
        dispatch(toggleTabs("aadhaar"));
        navigate("/kyc",{ replace: true });
      }
      navigate("/kyc",{ replace: true });
    }else if(channelUrl==="maruti" && customerType === "C"){
        let checkMarutiStatusData = {
          method: "get",
          url: `${process.env.REACT_APP_BASE_URL}/partner/kyc-status/transaction-id/${mi_u}`,
          headers: {
            "Content-Type": "application/json",
            token: token,
          },
        };
  
        axios(checkMarutiStatusData)
          .then(function (response) {
            console.log("Response",response)
            if (response.data.data.status === "approved" || response.data.data.status === "pending for verification") {
              console.log("Response we grt we user visit again",response.data.data);
              navigate("/Success", {
                state: { kyc_ref_id: response?.data?.data?.kyc_id,
                  status:response?.data?.data?.status, },
              });
            }else{
              navigate("/corporatePage", { replace: true }) 
            }
          })
          .catch(function (error) {
            navigate("/corporatePage", { replace: true })
            console.log(error);
          });
    
    }else if (token && customerType === "C") {
      if(kycID && Is_IDV3_Boolean){
        KydDetailsByKycID(kycID,"C")
          .then((response) => {
            console.log(response)
            if (response?.success === true) {
              if (Object.keys(response?.data)?.length > 1) {
                const {name,typeOfCompany,beneficialOwnership,
                  industryType,
                  organisationType,
                  pep_flag,
                  aadhaarNumber,
                  voteridNumber,
                  drivingLicenceNumber,
                  passportNumber,
                  beneficialOwnershipDetails }= response?.data // to be changed after checking 
                if(typeOfCompany==='trust') dispatch(corporateCompanyType('Trust'))
                if(typeOfCompany==='societyOrEducationalInstitute') dispatch(corporateCompanyType('Society or Educational Institution'))
                if(typeOfCompany==='partnershipFirm') dispatch(corporateCompanyType('Partnership Firm'))
                if(typeOfCompany==='llp') dispatch(corporateCompanyType('LLP'))
                if(typeOfCompany==='foreignEntity') dispatch(corporateCompanyType('Foreign Entity'))
                dispatch(corporateCDD({ beneficialOwnership,
                industryType,
                organisationType,
                pep_flag,
                aadhaarNumber,
                voteridNumber,
                drivingLicenceNumber,
                passportNumber,
                beneficialOwnershipDetails}))
                dispatch(coAddNewKycIdReducer(kycID))
                dispatch(updateCompanyName(name))
                dispatch(updateIsRecordExist(true))
                navigate("/corporate_edd",{
                  state: { modal: true,kyc_Id:kycID,kyccompanyName:name },
                });
               }
              }
          })
          .catch((err) => {
            console.log(err)
            dispatch(
              showGlobalError("Something went wrong. Please try again")
            );
            navigate("/*");
          });
      }
       navigate("/corporatePage", { replace: true }) 
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, customerType]);
  return <></>;
};

export default VerifiedPartner;
